const SQUARE_CARD_WIDTH_PX = 280;
const SQUARE_CARD_HEIGHT_PX = 120;
const SQUARE_CARD_GRID_GAP_PX = 20;

export const SQUARE_CARD_WIDTH = `${SQUARE_CARD_WIDTH_PX}px`;
export const SQUARE_CARD_HEIGHT = `${SQUARE_CARD_HEIGHT_PX}px`;
export const SQUARE_CARD_GRID_GAP = `${SQUARE_CARD_GRID_GAP_PX}px`;
export const SQUARE_DOUBLE_CARD_HEIGHT = `${SQUARE_CARD_HEIGHT_PX * 2 + SQUARE_CARD_GRID_GAP_PX}px`;

// Three wide letters overflow the 40px avatar at its larger font size.
export const SQUARE_AVATAR_LARGE_FONT_MAX_CHARACTERS = 2;
